import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: "login-container",
    templateUrl: "./login-container.component.html",
    styleUrls: ["./login-container.component.scss"]
})
export class LoginContainerComponent implements OnInit {
    @Input() public titel: string;
    @Input() public arbejder: boolean;
    @Output() public tilbage = new EventEmitter<void>();
    public overskrift$: Observable<string>;
    constructor(private indstillingerObserver: UmbracoIndstillingerObserver) {}
    public ngOnInit(): void {
        this.overskrift$ = this.indstillingerObserver.valueChanges.pipe(map((value) => value.aktuelEforsyning.overskriftPaaLoginside));
    }
}
